import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,
	
	state: {
		vehicles: [],
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/center/{centerId}/user/{username}/buses-data')
				.then(({ data }) => {
					commit(types.STORE_VEHICLES, data);
					return data;
				})
		},

		fetchPath({ commit }, { id }) {
			return axios.get('/center/{centerId}/user/{username}/bus-route', {
				params: { busId: id }
			}).then(({ data }) => {
				return data;
			})
		},

		updatePath({ commit }, { id, points }) {
			const routePoints = points.map(c => ({ Lat: c.lat, Lng: c.lng }))
			return axios.post('/center/{centerId}/user/{username}/bus-route', routePoints, {
				params: { busId: id }
			}).then(({ data }) => {
				return data;
			})
		},

		reset({ commit }) {
			commit(types.RESET);
		},

		restartGPSdata({ commit }) {
			return axios.get('/center/{centerId}/user/{username}/refresh');
		}
	},

	mutations: {
		[types.STORE_VEHICLES](state, vehicles) {
			state.vehicles = vehicles
		},
		[types.RESET](state) {
			state.vehicles = [];
		}
	},

	getters: {
		getVehiclesByBusNo: state => busNo => state.vehicles.find(v => v.BusNo === busNo),
		getVehiclesByBusId: state => busId => state.vehicles.find(v => v.Id === busId),
	}
}